<template>
  <div class="check-list-detailed" v-if="checkList">
    <h1 class="title is-4">{{ checkList.name }}</h1>
    <h2 class="subtitle is-6 nl">{{ checkList.description }}</h2>

    <table class="table is-bordered is-striped is-hoverable">
      <tbody>
        <tr v-for="(check, index) in checkList.checks" :key="index">
          <td :colspan="check.type === 'checkbox' ? 1 : 2">
            <div class="bold" :class="check.type === 'checkbox' ? 'text-left' : 'text-left'">{{ check.name }}</div>
            <template v-if="editable">
              <template v-if="check.type === 'text'">
                <b-input type="textarea" @input="changed()" v-model="check.value" />
              </template>
              <template v-else-if="check.type === 'number'">
                <b-input type="number" @input="changed()" v-model="check.value" />
              </template>
              <!-- Comment -->
              <b-input v-if="check.showComment"
                type="textarea"
                v-model="check.comment"
                @input="changed()"
                placeholder="comment" />
            </template>
            <template v-else>
              <template v-if="check.type === 'text'">
                <div class="nl">{{ check.value }}</div>
              </template>
              <template v-else-if="check.type === 'number'">
                {{ check.value | prettyNumber }}
              </template>
              <!-- Comment -->
              <div class="comment" v-if="check.comment && check.comment.length">{{ check.comment }}</div>
            </template>
          </td>
          <td class="text-center" v-if="check.type === 'checkbox'" style="width: 60px;" @click="checkClicked(check)">
            <div v-if="check.type === 'checkbox'"
              :class="{'has-text-success': check.value === 'yes', 'has-text-danger': check.value === 'no', 'has-text-grey': check.value === 'na'}"
            >
              <template v-if="check.value === ''">
                -
              </template>
              <template v-else-if="check.value !== 'na'">
                <font-awesome-icon v-if="check.value !== 'na'" :icon="check.value === 'yes' ? 'check' : 'times'" size="2x" />
              </template>
              <template v-else>
                <div class="bold" style="font-size: 1.45em">NA</div>
              </template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: 'CheckListDetailed',
  props: {
    checkList: { default: null },
    editable: { default: false },
    debounceTime: { default: 2000 }
  },
  data () {
    return {
      debounceTimer: null
    }
  },
  beforeDestroy () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.emitChanged()
    }
  },
  methods: {
    checkClicked (check) {
      if (!this.editable) {
        return
      }

      if (check.type === 'checkbox') {
        switch (check.value) {
          case 'yes':
            check.value = 'no'
            break
          case 'no':
            check.value = check.allowNa ? 'na' : 'yes'
            break
          default:
            check.value = 'yes'
        }
        this.changed()
      }
    },
    changed () {
      if (!this.editable) {
        return
      }
      if (this.debounceTime) {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(this.emitChanged, this.debounceTime)
      }
    },
    emitChanged () {
      if (!this.editable) {
        return
      }
      this.$emit('changed', this.checkList)
    }
  }
}
</script>

<style>
  .check-list-detailed textarea.textarea {
    /* height: 0px; */
    min-height: 70px;
    margin-top: 5px;
  }
</style>
